import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useLazyQuery } from "@apollo/react-hooks";

import SectionContainer from "core/SectionContainer";
import IconGrid from "icons/IconGrid";
import Heading from "core/Heading";

import colors from "core/colors";
import breakpoints from "core/breakpoints";
import Button from "core/Button";

import { ButtonContainer } from "./styles";

import { GET_SIMILAR_ICONS_DATA } from "./queries";

import { useViewport } from "js/hooks/useViewport";
import { convertPxToRem } from "frontend/components/helpers";

import { BROWSE_ICONS_SIMILAR } from "data/links";

const SimilarIcons = ({ slugWithId }) => {
    const iconId = slugWithId.split("-").pop();

    const { browserWidth } = useViewport();
    const onDesktop = browserWidth >= breakpoints.desktop.px;
    const onTablet =
        browserWidth < breakpoints.desktop.px &&
        browserWidth >= breakpoints.tablet.px;
    const onMobile = browserWidth < breakpoints.tablet.px;

    let numberOfRows;
    let numberOfColumns;
    let thumbnailSize;
    let gridSpacingSize;

    if (onDesktop || onTablet) {
        numberOfRows = 8;
        numberOfColumns = 5;
        thumbnailSize = 200;
        gridSpacingSize = convertPxToRem({ px: 24 });
    }

    if (onMobile) {
        numberOfRows = 15;
        numberOfColumns = 2;
        thumbnailSize = 84;
        gridSpacingSize = convertPxToRem({ px: 16 });
    }

    const [getSimilarIcons, { loading, data }] = useLazyQuery(
        GET_SIMILAR_ICONS_DATA
    );

    useEffect(() => {
        getSimilarIcons({
            variables: {
                iconId,
                limit: numberOfRows * numberOfColumns,
                thumbnailSize
            }
        });
    }, [iconId, onDesktop, onTablet, onMobile]);

    if (loading || !data || !data.similarIcons.items.length) return null;

    const similarIconsBrowsePage = `${BROWSE_ICONS_SIMILAR.replace(
        ":slugWithId",
        slugWithId
    )}`;

    return (
        <SectionContainer topSpacing="none" bottomSpacing="3xl">
            <Heading
                type="div"
                size="xs"
                bottomSpacing="2xl"
                headingColor={colors.secondary.orca}
            >
                You may also like
            </Heading>
            <IconGrid
                iconData={data.similarIcons.items}
                numberOfColumns={numberOfColumns}
                gridSpacingSize={gridSpacingSize}
                useRouterLink={true}
            />
            <ButtonContainer>
                <Button
                    href={similarIconsBrowsePage}
                    width={convertPxToRem({ px: 130 })}
                    size="md"
                >
                    See All
                </Button>
            </ButtonContainer>
        </SectionContainer>
    );
};

SimilarIcons.propTypes = {
    slugWithId: PropTypes.string.isRequired
};

export default SimilarIcons;
